<script lang="ts">
    import { tick } from 'svelte'

    import LoadingPattern from 'hydria/components/LoadingPattern.svelte'
    import { gettext as _ } from 'hydria/services/gettext'
    import { DateTime, toLuxon } from 'hydria/utils/time'

    import { d3, nv, nvReady } from 'wdom/utils/nvd'

    import type { IEntry } from './nsd_defs'

    interface Props {
        loading: boolean
        entries: IEntry[] | undefined
    }

    let { loading, entries }: Props = $props()

    let chart: any
    let chartSvg: any

    interface GData {
        ikey: string
        key: string
        color: string
        strokeWidth?: number
        values: any[]
    }
    const gdata: GData[] = [
        { ikey: 'min', key: 'Minimum', color: '#c8ddec', strokeWidth: 1, values: [] },
        { ikey: 'q1', key: '1er quartile', color: '#f2d8fe', values: [] },
        { ikey: 'median', key: 'Mediane (q2)', color: '#a000f9', values: [] },
        { ikey: 'q3', key: '3è quartile', color: '#f2d8fe', values: [] },
        { ikey: 'max', key: 'Maximum', color: '#c8ddec', strokeWidth: 1, values: [] },
        { ikey: 'avg', key: 'Moyenne', color: '#1f77b4', strokeWidth: 1, values: [] },
    ]

    let charted = false
    function createChart() {
        if (charted) {
            return
        }
        charted = true

        for (const gd of gdata) {
            gd.values = []
        }

        // @ts-expect-error
        for (const e of entries) {
            for (const gd of gdata) {
                gd.values.push({
                    x: e.hour,
                    y: e[gd.ikey],
                })
            }
        }

        tick().then(() => {
            nv.addGraph(() => {
                chart = nv.models.lineChart().id(
                    Math.random()
                        .toString(36)
                        .slice(2, 2 + 15),
                )
                // chart.height(275)
                // chart.width(275)
                chart.xAxis
                    // .rotateLabels(50)
                    .showMaxMin(false)
                    .axisLabel('Day::Hour')
                    .tickFormat((d: DateTime) => {
                        // return DateTime.now().minus({ days: d }).toFormat('yyyy-MM-dd')
                        return toLuxon(d).toFormat('dd::HH')
                    })
                chart.yAxis
                    .showMaxMin(false)
                    .axisLabel('Ping (ms)')
                    .tickFormat((d: number) => {
                        return d / 1000
                    })
                chart.yScale(d3.scale.log())
                chart.margin({
                    top: 20,
                    right: 20,
                    bottom: 50,
                    left: 60,
                })

                chartSvg = d3.select('#chart-nsd-server-ping')
                chartSvg.datum(gdata).call(chart)
            })
        })
    }

    $effect(() => {
        if ($nvReady && loading == false && entries != null) createChart()
    })
</script>

<style>
    #chart-nsd-server-ping {
        height: 450px;
        width: 100%;
    }
</style>

<div class="card">
    <div class="card-title text-primary">Ping</div>
    {#if loading !== false}
        <div class="card-body">
            <LoadingPattern pattern={['x', 'x', 'x', 'x']} />
        </div>
    {:else}
        <div class="card-body">
            <svg id="chart-nsd-server-ping" class="nvd3-svg" />
        </div>
    {/if}
</div>
